import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import ComponentHeader from '../../components/Headers/component-header';
import InlineQuery from '../../components/InlineQuery';
import List from '../../components/List/List';
import SectionedItems from '../../components/SectionedItems';
import ActorItem from '../../components/SectionedItems/ActorItem';
import {
  formatTrendingActors,
  formatTrendingMovies,
  formatTopMovies,
  formatAnticipatedMovies
} from '../../utils/homepage';

import './Homepage.css';

const trendingHeaders = [
  { key: 'title', label: 'Title' },
  { key: 'studio', label: 'Studio' },
  { key: 'percentIncrease', label: '% Growth' }
];

const anticipatedHeader = [
  { key: 'title', label: 'Title' },
  { key: 'studio', label: 'Studio' },
  { key: 'releaseDate', label: 'Release Date' }
];

const topTitlesHeaders = [
  { key: 'title', label: 'Title' },
  { key: 'studio', label: 'Studio' },
  {
    key: 'viewShare',
    label: 'Share of Views',
    tooltip:
      'The portion of all Views, for selected filter criteria, belonging to a specific piece of content'
  },
  { key: 'viewers', label: 'Viewers' }
];

const HomePageMovies = ({ queries, formatFiltersForURL }) => (
  <>
    <Row className="tvt-homepage__row movie-row">
      <Col md={12}>
        <div className="tvt-homepage__chart-header">
          <ComponentHeader
            title="Top Performing Titles"
            tooltip="This reports highlight the most watched movies in the past 7 completed days"
          />
          <Link
            className="tvt-homepage__see-all-link"
            to={`/movies?${formatFiltersForURL(true)}`}
          >
            SEE ALL
          </Link>
        </div>

        <InlineQuery query={queries.topPerformingMovies}>
          {query => (
            <div className="tvt-homepage__top-titles">
              <List
                headers={topTitlesHeaders}
                data={formatTopMovies(query)}
                bodyClass="tvt-report-list__body--no-padding"
              />
            </div>
          )}
        </InlineQuery>
      </Col>
    </Row>
    <Row className="tvt-homepage__row">
      <Col md={6}>
        <div className="tvt-homepage__chart-header">
          <ComponentHeader
            title="Anticipated Titles"
            tooltip="This report showcases the top 10 most followed unreleased movies on the TV Time app"
          />
          <Link
            className="tvt-homepage__see-all-link"
            to={`/movies/anticipation-report?${formatFiltersForURL()}`}
          >
            SEE ALL
          </Link>
        </div>

        <InlineQuery query={queries.homepageMoviesAnticipation}>
          {query => (
            <div className="tvt-homepage__anticipated-titles">
              <List
                headers={anticipatedHeader}
                data={formatAnticipatedMovies(query)}
                bodyClass="tvt-report-list__body--no-padding"
              />
            </div>
          )}
        </InlineQuery>
      </Col>
      <Col md={6}>
        <div className="tvt-homepage__chart-header">
          <ComponentHeader
            title="Titles on the Rise"
            tooltip="This report highlights the top 10 movies by follower growth in the past 7 completed days"
          />
          {/* <Link
            className="tvt-homepage__see-all-link"
            to="/movies/anticipation-report"
          >
            SEE ALL
          </Link> */}
        </div>

        <InlineQuery query={queries.trendingMovies}>
          {query => (
            <div className="tvt-homepage__trending-titles">
              <List
                headers={trendingHeaders}
                data={formatTrendingMovies(query)}
                bodyClass="tvt-report-list__body--no-padding"
              />
            </div>
          )}
        </InlineQuery>
      </Col>
    </Row>
    <Row className="tvt-homepage__row">
      <Col md={12}>
        <ComponentHeader
          title="Trending Talent: New Fan Votes this Week"
          tooltip="This report highlights the top performing movie characters by total character votes in the past 7 completed days"
        />
        <InlineQuery query={queries.trendingActors}>
          {query => (
            <SectionedItems
              list={formatTrendingActors(query)}
              itemType={ActorItem}
              hasSeparators={false}
            />
          )}
        </InlineQuery>
      </Col>
    </Row>
  </>
);

export default HomePageMovies;

HomePageMovies.propTypes = {
  queries: PropTypes.shape({
    trendingMoviesActors: PropTypes.shape({}),
    trendingMovies: PropTypes.shape({}),
    topPerformingMovies: PropTypes.shape({}),
    homepageMoviesAnticipation: PropTypes.shape({}),
    trendingActors: PropTypes.shape({})
  }).isRequired,
  formatFiltersForURL: PropTypes.func.isRequired
};
